import React from 'react';
import CheckCircle from './icons/CheckCircle.js';
import CrossCircle from './icons/CrossCircle.js';
import ExclamationTriangle from './icons/ExclamationTriangle.js';
import InfoCircle from './icons/InfoCircle.js';

function getIcon(type) {
    switch (type) {
        case 'positive':
            return CheckCircle;
        case 'negative':
            return CrossCircle;
        case 'danger':
            return ExclamationTriangle;
        default:
            return InfoCircle;
    }
}
function getIconCss(type) {
    switch (type) {
        case 'positive':
            return 'text-green-500';
        case 'negative':
            return 'text-red';
        case 'danger':
            return 'text-yellow';
        default:
            return 'text-gray-400';
    }
}
const Icon = ({ className = '', filled = true, type = 'info', ...props }) => {
    const IconEl = getIcon(type);
    return (React.createElement(IconEl, { className: [getIconCss(type), className].join(' '), ...{ ...props, filled } }));
};

export { Icon };
//# sourceMappingURL=Icon.js.map
